import { createContext, useContext } from "react";
import type { DropSide } from "../../utils/methods/columnOrder";

/** react-dnd item type for table column headers. */
export const TABLE_COLUMN_DND_TYPE = "TABLE_COLUMN";

export type ColumnDragItem = { id: string };

export type ColumnReorderApi = {
  moveColumn: (fromId: string, toId: string, side: DropSide) => void;
};

export const ColumnReorderContext = createContext<ColumnReorderApi | null>(
  null,
);

/** `moveColumn` of the nearest `ColumnReorderProvider`, or null when the table is not reorderable. */
export function useColumnReorder(): ColumnReorderApi | null {
  return useContext(ColumnReorderContext);
}
